import React from "react";
import { Link } from "react-router-dom";
import { withClientContainer } from "../normalizer";
import { t } from "../../../i18n";
import CustomLink from "./CustomLink";

const If = ({ condition, children }) => {
  if (condition) {
    return children;
  } else {
    return null;
  }
};

const Footer = ({ fontFamily, client, campaign, features, clientSlug }) => {
  const footerClasses = ["gl-footer"].join(" ");

  const findFeatureByName = (name) => {
    const feature = features.find((f) => f.name === name);
    return feature;
  };

  const showRegulations = () => {
    const feature = findFeatureByName("Configuracao de Footer");
    const options = campaign.options;
    return typeof feature != "undefined"
      ? options && options.show_regulations
      : true;
  };

  const showRules = () => {
    const feature = findFeatureByName("Configuracao de Footer");
    const options = campaign.options;
    return typeof feature != "undefined" ? options && options.show_rules : true;
  };

  // Get logo from campaign
  const logo =
    campaign && campaign.images && campaign.images.logo
      ? campaign.images.logo.url
      : null;

  // Get contact info from client
  const phone = client && client.phone ? client.phone : "210 967 025";
  const email = client && client.email ? client.email : "galp@galp.pt";

  return (
    <footer className={footerClasses}>
      <div className="gl-footer__container">
        <div className="gl-footer__content">
          {/* Column 1: Logo */}
          <div className="gl-footer__logo">
            {logo && <img src={logo} alt="logo" />}
          </div>

          {/* Column 2: Links rápidos */}
          <div className="gl-footer__column">
            <div className="gl-footer__title--2026">
              {t("gamification2026.footer.quick-links")}
            </div>
            <ul className="gl-footer__list">
              <If condition={showRules()}>
                <li className="gl-footer__item">
                  <Link className="gl-footer__link" to="/utility-info/rules">
                    {t("gamification2026.footer.rules")}
                  </Link>
                </li>
              </If>
              <If condition={showRegulations()}>
                <li className="gl-footer__item">
                  <Link
                    className="gl-footer__link"
                    to="/utility-info/regulation"
                  >
                    {t("gamification2026.footer.regulation")}
                  </Link>
                </li>
              </If>
              <li className="gl-footer__item">
                <Link className="gl-footer__link" to="/terms">
                  {t("gamification2026.footer.terms")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contactos */}
          <div className="gl-footer__column">
            <h4 className="gl-footer__title--2026">
              {t("gamification2026.footer.contacts")}
            </h4>
            <ul className="gl-footer__list">
              <li className="gl-footer__item">
                <span className="gl-footer__contact-text">{phone}</span>
              </li>
              <li className="gl-footer__item">
                <a className="gl-footer__link" href={"mailto:" + email} target="_self" >
                  {email}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Empty */}
          <div className="gl-footer__column gl-footer__column--empty"></div>
        </div>
      </div>
    </footer>
  );
};

export default withClientContainer(Footer);
